import classNames from "classnames";
import {Modal} from "react-bootstrap";

import {useCurrentUserContext} from "@/components/context/hooks";
import {useFeatureBase} from "@/components/feedback/FeatureBase";
import {ITabContentLayoutProps} from "@/components/layout/TabModalContainer.types.ts";
import {NavTabs} from "@/components/navTabs/NavTabs.tsx";
import {useGTM} from "@/components/trackers/GoogleTagEvents.ts";

import styles from "./TabModalContainer.module.scss";

export const TabModalContainer = ({
  sections,
  topActionsBar,
  bottomActionsBar,
  children,
  tab,
  setTab,
  className,
  headerClassName,
  title,
  onHide,
}: ITabContentLayoutProps) => {
  const {user} = useCurrentUserContext();
  useGTM(user);
  const {init: initFeatureBase} = useFeatureBase();
  if (user) {
    initFeatureBase(user);
  }

  return (
    <Modal onHide={onHide} size="lg" centered show>
      <Modal.Header closeButton className="py-4">
        <Modal.Title className="w-100 pe-1">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-0">
        <div className={classNames(styles.stickyHeader, headerClassName)}>
          <div className="d-flex flex-row justify-content-between pt-3">
            <NavTabs
              items={Object.values(sections).filter((s) => s.isVisible)}
              selectedId={sections[tab].id}
              className={styles.tabTitles}
              selectTab={(tabName) => {
                setTab(tabName);
              }}
            />
            <div>{topActionsBar}</div>
          </div>
        </div>
        <div className={classNames(styles.tabContent, className)}>{children}</div>
      </Modal.Body>
      {bottomActionsBar && <Modal.Footer>{bottomActionsBar}</Modal.Footer>}
    </Modal>
  );
};
